/**
 * RANK バッジ(cc-system 固有。設計書 §3-2 ＋ 2026-09-18 修正1)。
 * 色は評価段階のトークン(--color-grade-1〜5)で、状態色(赤黄緑)とは別体系。
 * **RANK の根拠の数値(見込取得数/h)にも同じ色を付ける**(MTG「RANKと数字を同じ色に」)→ rankTextClass。
 * 判定の基準は既存の業務仕様(dashboard/calc.ts の rankOf)のまま。ここは表示だけ。
 */
export type RankValue = 'S' | 'A' | 'B+' | 'B-' | 'C';

const GRADE: Record<RankValue, number> = { S: 1, A: 2, 'B+': 3, 'B-': 4, C: 5 };

const isRank = (v: string | null | undefined): v is RankValue => !!v && v in GRADE;

/** 数値の文字色に使うクラス(RANK が無いときは色を付けない) */
export function rankTextClass(rank: string | null | undefined): string {
  return isRank(rank) ? `rank-text rank-g${GRADE[rank]}` : '';
}

export default function RankBadge({ rank }: { rank: string | null | undefined }) {
  if (!isRank(rank)) return <span className="rank-badge is-none">—</span>;
  return (
    <span className={`rank-badge rank-g${GRADE[rank]}`} aria-label={`RANK ${rank}`}>
      {rank}
    </span>
  );
}
